import { LoginManagementRoutes } from "../LoginManagementRoutes";

const ROOT = LoginManagementRoutes.SID;

export const SIdentitySettingsRoutes = {
    ROOT,
    USERNAME: ROOT + "/username",
    USERNAME_SIGNING: ROOT + "/username-signing",
    USERNAME_SUCCESS: ROOT + "/username-success",
    DELETE_USERNAME_SIGNING: ROOT + "/delete-username-signing",
    DELETE_USERNAME_SUCCESS: ROOT + "/delete-username-success",
    DELETE_SIGNING: ROOT + "/delete-signing",
    DELETE_SUCCESS: ROOT + "/delete-success",
    CODE: ROOT + "/code",
    ONBOARDING_LIMIT: ROOT + "/limit",
    ONBOARDING_LIMIT_SIGNING: ROOT + "/limit/signing",
    ONBOARDING_LIMIT_SUCCESS: ROOT + "/limit/success",
    LIMIT: ROOT + "/limit-management",
    LIMIT_SIGNING: ROOT + "/limit-management/signing",
    LIMIT_SUCCESS: ROOT + "/limit-management/success",
    ADD_DEVICE_CATEGORY: ROOT + "/add-device-category",
    ADD_DEVICE_SUMMARY: ROOT + "/add-device-summary",
    ADD_DEVICE_SIGNING: ROOT + "/add-device-signing",
    ADD_DEVICE_SUCCESS: ROOT + "/add-device-success",
    ADD_DESKTOP_DEVICE_INFO: ROOT + "/add-desktop-device-info",
    ACTIVATE_GEORGE_ID: ROOT + "/activate-george-id",
    ERROR_SIGNING_METHOD: ROOT + "/error-signing-method",
};


// WEBPACK FOOTER //
// ./src/components/loginManagement/sIdentitySettings/SIdentitySettingsRoutes.tsx